import React from 'react';
import ShowCode from "../helpers/ShowCode.js";
import {Box, Button, Divider, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import FaAccordion from "../FactureeComponents/FaAccordion";
import Chip from "@mui/material/Chip";

const FactureeCompAccordionExmpl = () => {

  const example1 = `<>
  <FaAccordion title={"Facturee Accordion Header Regular"} statusIndication={"ok"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Header Large"} headerSize={"large"} statusIndication={"ok"}></FaAccordion>
</>`;

  const example2 = `<>
  <FaAccordion title={"Facturee Accordion Expand Icon left"} expandIconPos={"left"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Expand Icon right"} expandIconPos={"right"}></FaAccordion>
</>`;

  const example3 = `<>
  <FaAccordion title={"Facturee Accordion Level 1"} expandIconPos={"left"} variant={"level1"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Level 2"} expandIconPos={"left"} variant={"level2"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Level 3"} expandIconPos={"left"} variant={"level3"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Level 4"} expandIconPos={"left"} variant={"level4"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Accounting"} expandIconPos={"left"} variant={"accounting"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Logistics"} expandIconPos={"left"} variant={"logistics"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Packaging"} expandIconPos={"left"} variant={"packaging"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Purchase"} expandIconPos={"left"} variant={"purchase"}></FaAccordion>
  <FaAccordion title={"Facturee Accordion Sales"} expandIconPos={"left"} variant={"sales"}></FaAccordion>
</>`;

  const example4 = `<>
  <FaAccordion title={"Facturee Accordion OK"}
               expandIconPos={"left"}
               statusIndication={"ok"}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Warn"}
               expandIconPos={"left"}
               statusIndication={"warn"}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Error"}
               expandIconPos={"left"}
               statusIndication={"error"}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Automation"}
               expandIconPos={"left"}
               statusIndication={"automate"}></FaAccordion>

  <FaAccordion title={"Facturee Accordion New"}
               expandIconPos={"left"}
               statusIndication={"new"}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Renew"}
               expandIconPos={"left"}
               statusIndication={"renew"}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Stared"}
               expandIconPos={"left"}
               statusIndication={"star"}></FaAccordion>

  <FaAccordion title={"Facturee Accordion File-is-present"}
               expandIconPos={"left"}
               statusIndication={"file"}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Schedule"}
               expandIconPos={"left"}
               statusIndication={"schedule"}></FaAccordion>
</>`;

  const example5 = `<>
  <FaAccordion title={"Facturee Accordion OK"}
               expandIconPos={"left"}
               statusIndication={"ok"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['OK']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Warn"}
               expandIconPos={"left"}
               statusIndication={"warn"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['Warning']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Error"}
               expandIconPos={"left"}
               statusIndication={"error"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['Error']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Automation"}
               expandIconPos={"left"}
               statusIndication={"automate"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['Automating …']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion New"}
               expandIconPos={"left"}
               statusIndication={"new"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['This is NEW.']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Renew"}
               expandIconPos={"left"}
               statusIndication={"renew"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['Renew!']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Stared"}
               expandIconPos={"left"}
               statusIndication={"star"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['A Star!']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion File-is-present"}
               expandIconPos={"left"}
               statusIndication={"file"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['A File is present.']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Schedule"}
               expandIconPos={"left"}
               statusIndication={"schedule"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['Time matters.']}></FaAccordion>

  <FaAccordion title={"Facturee Accordion Schedule"}
               expandIconPos={"left"}
               statusIndication={"delete"}
               onStatusClick={(msg:string)=>alert(msg)}
               onStatusParams={['Delete this!']}></FaAccordion>
</>`;

  const example6 = `<>
  <FaAccordion title={"Facturee Accordion Custom Inject"}
               expandIconPos={"left"}
               customHeaderEntry={
                  <Chip label="Hello Custom Element injected" variant="outlined" onClick={(e) => {e.stopPropagation(); alert('A custom function call.');}} sx={{marginTop: '-7px', transform:"translateY(3px)"}}/>
               }></FaAccordion>

  <FaAccordion title={"Facturee Accordion Custom Inject and Status Button"}
                 expandIconPos={"left"}
                 statusIndication={"delete"}
                 onStatusClick={(msg:string)=>alert(msg)}
                 onStatusParams={['Delete this!']}
                 customHeaderEntry={
                     <Chip label="Hello Custom Element injected" variant="outlined" onClick={(e) => {e.stopPropagation(); alert('A custom function call.');}} sx={{marginTop: '-7px', transform:"translateY(3px)"}}/>
                 }></FaAccordion>
</>`;

  return (
    <Box sx={{padding: '8rem 8vw 2rem 8vw'}}>
      <Typography variant={"h3"} sx={{marginBottom: '2rem'}}>FaAccordion Component</Typography>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Size</Typography>
      <>
        <FaAccordion title={"Facturee Accordion Header Regular"} statusIndication={"ok"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Header Large"} headerSize={"large"} statusIndication={"ok"}></FaAccordion>
      </>

      <ShowCode codeString={example1} scope={{ React, Button, FaAccordion }} />

      <Divider/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Expand Icon Position</Typography>
      <>
        <FaAccordion title={"Facturee Accordion Expand Icon left"} expandIconPos={"left"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Expand Icon right"} expandIconPos={"right"}></FaAccordion>
      </>
      
      <ShowCode codeString={example2} scope={{ React, Button, FaAccordion }} />
      
      <Divider/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Variants</Typography>
      <>
        <FaAccordion title={"Facturee Accordion Level 1"} expandIconPos={"left"} variant={"level1"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Level 2"} expandIconPos={"left"} variant={"level2"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Level 3"} expandIconPos={"left"} variant={"level3"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Level 4"} expandIconPos={"left"} variant={"level4"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Accounting"} expandIconPos={"left"} variant={"accounting"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Logistics"} expandIconPos={"left"} variant={"logistics"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Packaging"} expandIconPos={"left"} variant={"packaging"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Purchase"} expandIconPos={"left"} variant={"purchase"}></FaAccordion>
        <FaAccordion title={"Facturee Accordion Sales"} expandIconPos={"left"} variant={"sales"}></FaAccordion>
      </>
      
      <ShowCode codeString={example3} scope={{ React, Button, FaAccordion }} />
      
      <Divider/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Status Indication</Typography>
      <>
        <FaAccordion title={"Facturee Accordion OK"}
                     expandIconPos={"left"}
                     statusIndication={"ok"}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Warn"}
                     expandIconPos={"left"}
                     statusIndication={"warn"}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Error"}
                     expandIconPos={"left"}
                     statusIndication={"error"}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Automation"}
                     expandIconPos={"left"}
                     statusIndication={"automate"}></FaAccordion>

        <FaAccordion title={"Facturee Accordion New"}
                     expandIconPos={"left"}
                     statusIndication={"new"}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Renew"}
                     expandIconPos={"left"}
                     statusIndication={"renew"}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Stared"}
                     expandIconPos={"left"}
                     statusIndication={"star"}></FaAccordion>

        <FaAccordion title={"Facturee Accordion File-is-present"}
                     expandIconPos={"left"}
                     statusIndication={"file"}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Schedule"}
                     expandIconPos={"left"}
                     statusIndication={"schedule"}></FaAccordion>
      </>
      
      <ShowCode codeString={example4} scope={{ React, Button, FaAccordion }} />
      
      <Divider/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Status Indication with Button Functionality</Typography>
      <>
        <FaAccordion title={"Facturee Accordion OK"}
                     expandIconPos={"left"}
                     statusIndication={"ok"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['OK']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Warn"}
                     expandIconPos={"left"}
                     statusIndication={"warn"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['Warning']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Error"}
                     expandIconPos={"left"}
                     statusIndication={"error"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['Error']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Automation"}
                     expandIconPos={"left"}
                     statusIndication={"automate"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['Automating …']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion New"}
                     expandIconPos={"left"}
                     statusIndication={"new"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['This is NEW.']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Renew"}
                     expandIconPos={"left"}
                     statusIndication={"renew"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['Renew!']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Stared"}
                     expandIconPos={"left"}
                     statusIndication={"star"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['A Star!']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion File-is-present"}
                     expandIconPos={"left"}
                     statusIndication={"file"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['A File is present.']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Schedule"}
                     expandIconPos={"left"}
                     statusIndication={"schedule"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['Time matters.']}></FaAccordion>

        <FaAccordion title={"Facturee Accordion Schedule"}
                     expandIconPos={"left"}
                     statusIndication={"delete"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['Delete this!']}></FaAccordion>
      </>
      
      <ShowCode codeString={example5} scope={{ React, Button, FaAccordion }} />
      
      <Divider/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Custom Header Content</Typography>
      
      <>
        <FaAccordion title={"Facturee Accordion Custom Inject"}
                     expandIconPos={"left"}
                     customHeaderEntry={
                        <Chip label="Hello Custom Element injected" variant="outlined" onClick={(e) => {e.stopPropagation(); alert('A custom function call.');}} sx={{marginTop: '-7px', transform:"translateY(3px)"}}/>
                     }></FaAccordion>

        <FaAccordion title={"Facturee Accordion Custom Inject and Status Button"}
                     expandIconPos={"left"}
                     statusIndication={"delete"}
                     onStatusClick={(msg:string)=>alert(msg)}
                     onStatusParams={['Delete this!']}
                     customHeaderEntry={
                         <Chip label="Hello Custom Element injected" variant="outlined" onClick={(e) => {e.stopPropagation(); alert('A custom function call.');}} sx={{marginTop: '-7px', transform:"translateY(3px)"}}/>
                     }></FaAccordion>
      </>
      
      <ShowCode codeString={example6} scope={{ React, Button, FaAccordion, Chip }} />

      <Typography variant={"h4"} sx={{marginBottom: '0.5rem', marginTop: '3rem'}}>API Reference</Typography>
      <Typography variant={"body2"} color="text.secondary" sx={{marginBottom: '2rem'}}>
        Complete list of all props supported by the FaAccordion component.
      </Typography>

      <TableContainer component={Paper} sx={{marginBottom: '2rem', '& code': {fontSize: '0.875rem'}}}>
        <Table>
          <TableHead>
            <TableRow sx={{backgroundColor: 'primary.main'}}>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '20%'}}>Prop</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '25%'}}>Type</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '15%'}}>Default</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '40%'}}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell><code>title</code> *</TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>The title text displayed in the accordion header.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>id</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Optional ID attribute for the accordion summary element.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>children</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Content to be displayed inside the accordion details section.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>variant</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'level1' | 'level2' | 'level3' | 'level4' | 'accounting' | 'logistics' | 'packaging' | 'purchase' | 'sales'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"level1"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Visual variant defining the accordion's styling theme.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>sx</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Material-UI sx prop for custom styling.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>headerSize</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'small' | 'large'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"small"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Size of the accordion header; affects typography and padding.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>expandIcon</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>&lt;ExpandMoreIcon /&gt;</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Custom icon to display for expand/collapse functionality.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>expandIconPos</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'left' | 'right'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"right"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Position of the expand icon in the header.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>statusIndication</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'ok' | 'warn' | 'error' | 'automate' | 'new' | 'renew' | 'star' | 'file' | 'schedule' | 'delete'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Status icon to display in the header indicating the accordion's state.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>onStatusClick</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>Function</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Callback function triggered when the status icon is clicked; makes the icon interactive.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>onStatusParams</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any[]</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Parameters to pass to the onStatusClick callback function.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>customHeaderEntry</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Custom React element to inject into the header area.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>ariaControls</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"accordion-summary-content"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>ARIA controls attribute for accessibility.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>disabled</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>boolean</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>false</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>When true, disables the accordion preventing user interaction.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant={"body2"} color="text.secondary" sx={{fontStyle: 'italic'}}>
        * Required prop
      </Typography>

    </Box>
  );
};

export default FactureeCompAccordionExmpl;
